import store from '@/store'

/**
 * 根据平台 ID 获取平台名称
 * @param id 平台 ID
 * @returns 平台名称，不存在返回 '未知平台(ID)'
 */
export const getPlatformLabel = (id?: number): string => {
    if (!id) return '-'
    const list = store.getters['dict/getPlatformList'] || []
    const platform = list.find(item => item.id === id)
    return platform?.platform_abbreviation || id + ''
}
/**
 * 根据 ids 获取平台名称列表
 * 找不到的 ID 显示为数字本身
 * @param ids 平台 ID 数组
 * @returns 平台名称数组
 */
export const getPlatformLabels = (ids?: number[]): string[] => {
    if (!ids?.length) return []
    const list = store.getters['dict/getPlatformList'] || []
    return ids.map(id => {
        const platform = list.find((item: any) => item.id === id)
        // ✅ 找不到就显示 ID 本身（转成字符串）
        return platform?.platform_abbreviation || platform?.name || String(id)
    })
}
/**
 * 根据 ids 获取平台名称，用逗号拼接
 * 找不到的 ID 显示为数字本身
 * @param ids 平台 ID 数组
 * @param separator 分隔符，默认逗号
 * @returns 平台名称字符串，如 "淘宝,京东,3"
 */
export const getPlatformNamesStr = (ids?: number[], separator: string = '、'): string => {
    if (!ids?.length) return ''
    return getPlatformLabels(ids).join(separator)
}
